import { DeleteStatementParams } from 'app/dataTypes/cafeteria/compensation/statements'

import type { Request } from '../../../../index'


type ParamsApi = {
  withdraw_order_id: number
}

export const convertParams = ({ statementID }: DeleteStatementParams): [ParamsApi, null] => {
  return [{
    withdraw_order_id: parseInt(statementID, 10),
  }, null]
}

export const convertResult = (res: 'success'): boolean => {
  return !!res
}

export const POST_COMPENSATION_WITHDRAW_ORDERS_DELETE: Request<DeleteStatementParams, boolean, void> = [
  'cabinet/compensation/withdraw_orders/delete',
  'post',
  ['data', 'result'],
]
